var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 2.40002V6.00002C15.0002 6.66277 15.5375 7.20002 16.2002 7.20002H19.8002M8.4002 18V13.2M12.0002 18L12.0002 8.40002M15.6002 18V13.2M18.0002 4.20002C17.4661 3.72217 16.9119 3.1554 16.5621 2.7873C16.3292 2.54236 16.0076 2.40002 15.6696 2.40002H6.59992C5.27444 2.40002 4.19993 3.47453 4.19992 4.80001L4.19983 19.2C4.19982 20.5254 5.27433 21.6 6.59982 21.6L17.3999 21.6C18.7253 21.6 19.7998 20.5255 19.7999 19.2001L19.8002 6.47786C19.8002 6.17102 19.6831 5.87606 19.4702 5.65516C19.0764 5.24667 18.4188 4.57454 18.0002 4.20002Z",
    stroke: "#C1C5CF",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/Discover.4c7f4898e69cc5dbd7613cff5801ba28.svg";
export { ForwardRef as ReactComponent };